import { API_BASE_URL, getBaseHeaders } from './api.config';
import { throwApiError } from './api.error';
import { authenticatedCall } from './auth';

export const uploadSingleImage = async (
  file: File,
  type: 'ACCOUNT' | 'PRODUCT' = 'ACCOUNT'
): Promise<{ imageUrl: string }> => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await authenticatedCall(
    `${API_BASE_URL}/images/single?type=${type}`,
    {
      method: 'POST',
      headers: {
        ...getBaseHeaders(),
        'accept': 'application/json'
      },
      body: formData
    }
  );

  if (!response.ok) {
    await throwApiError(response);
  }

  return await response.json();
};
